import React, { createContext, useContext, useEffect, useState } from "react";

import { noop } from "lodash/fp";

import useTopicReportStore from "@app/analytics/TopicReport/hooks/useTopicReportStore";

interface TopicReportContext {
  mainScrollContainer: HTMLDivElement | null;
  setMainScrollContainer: (el: HTMLDivElement | null) => void;
}

const DEFAULT_TOPIC_REPORT_CONTEXT: TopicReportContext = {
  mainScrollContainer: null,
  setMainScrollContainer: noop,
};

export const TopicReportContext = createContext<TopicReportContext>(
  DEFAULT_TOPIC_REPORT_CONTEXT
);

export const useTopicReportContext = () => useContext(TopicReportContext);

export const TopicReportContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // don't use a ref here because we need to trigger a state update when the
  // scroll container is defined so that virtuoso can properly render on initial
  // page load
  const [mainScrollContainer, setMainScrollContainer] =
    useState<HTMLDivElement | null>(null);

  const resetState = useTopicReportStore((state) => state.resetState);

  useEffect(() => {
    // reset store state when navigating away from a report
    return resetState;
  }, []);

  const context: TopicReportContext = {
    mainScrollContainer,
    setMainScrollContainer,
  };

  return (
    <TopicReportContext.Provider value={context}>
      {children}
    </TopicReportContext.Provider>
  );
};
